<template>
  <div class="pc_container app-main-content">
    <div class="app-main-content-section bgfff">
      <div class="flex flex_between flex_items">
        <el-button type="primary" @click="shift">交班</el-button>
        <div>
          总金额：{{ amount }}
        </div>
      </div>

      <div class="page_title mt20 mb10">门票：</div>
      <el-table :data="ticked" style="width: 100%" :header-cell-style="{
        background: '#F3F3F3',
        color: '#1F3349',
        fontSize: '15px',
        fontWeight: 'normal',
      }" :cell-style="{ fontSize: '15px', color: '#666666' }">
        <el-table-column prop="name" label="票类" align="left" />
        <el-table-column prop="amount" label="总价" align="left" />
        <el-table-column prop="num" label="数量" align="left" />

        <el-table-column prop="refund" align="left" label="退票金额">
        </el-table-column>
        <el-table-column prop="refundNum" align="left" label="退票数量">
        </el-table-column>
        <div slot="empty" style="text-align: center;width:100%">
          暂无数据
        </div>
      </el-table>
      <div class="page_title mt20 mb10">年卡：</div>
      <el-table :data="yearCard" style="width: 100%" :header-cell-style="{
        background: '#F3F3F3',
        color: '#1F3349',
        fontSize: '15px',
        fontWeight: 'normal',
      }" :cell-style="{ fontSize: '15px', color: '#666666' }">
        <el-table-column prop="name" label="票类" align="left" />
        <el-table-column prop="amount" label="总价" align="left" />
        <el-table-column prop="num" label="数量" align="left" />

        <el-table-column prop="refund" align="left" label="退票金额">
        </el-table-column>
        <el-table-column prop="refundNum" align="left" label="退票数量">
        </el-table-column>
        <div slot="empty" style="text-align: center;width:100%">
          暂无数据
        </div>
      </el-table>
    </div>
  </div>
</template>
<script>
export default {
  name: '',
  components: {

  },
  mixins: [],
  props: {

  },
  data() {
    return {
      amount: 0,
      ticked: [],
      yearCard: []
    }
  },
  computed: {

  },
  watch: {

  },
  mounted() {
    this.api.getUrl('/api/v1/window/user/shift').then(res => {
      this.amount = res.amount;
      this.ticked = res.amountArr ? res.amountArr.ticked : [];
      this.yearCard = res.amountArr ? res.amountArr.yearCard : [];
    })
  },
  methods: {
    shift() {
      this.$confirm('确认交班?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.postUrl('/api/v1/window/user/shift', {}, { loading: true }).then(res => {
          this.$message.success('操作成功')
          this.amount = 0;
          this.ticked = [];
          this.yearCard = [];
        })
      }).catch(() => { });

    }
  }
};
</script>
<style lang='' scoped>
</style>